import React, { useState, useRef } from "react";
import Navbar from "../components/Navbar";
import "../styles/global.css";
import { apiPost } from "../utils/api";

export default function SendMessage() {
    const [mode, setMode] = useState("number"); // number | file
    const [phone, setPhone] = useState("");
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState("");
    const [media, setMedia] = useState(null);
    const [messageType, setMessageType] = useState("Text"); // Text, Image, Video, Audio, Document
    const [sendType, setSendType] = useState("instant");
    const [date, setDate] = useState("");
    const [time, setTime] = useState("");
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [address, setAddress] = useState("");
    const fileInputRef = useRef(null);

    const [fileLineCount, setFileLineCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const MESSAGE_TYPES = ["Text", "Image", "Video", "Audio", "Document", "Location"];

    const handleReset = () => {
        setPhone("");
        setFile(null);
        setMessage("");
        setMedia(null);
        setMessageType("Text");
        if (fileInputRef.current) fileInputRef.current.value = null;
        setSendType("instant");
        setDate("");
        setTime("");
    };

    // Count mobile numbers
    const countNumbers = phone
        .split(/[\n,]+/)
        .map((n) => n.trim())
        .filter((n) => n.length > 0).length;

    // Dynamic accept attribute for file input
    const getAcceptType = () => {
        switch (messageType) {
            case "Image":
                return ".jpg,.jpeg,.png";
            case "Video":
                return ".avi,.mp4";
            case "Audio":
                return ".mp3,.ogg";
            case "Document":
                return ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx";
            default:
                return "";
        }
    };

    // Media preview
    const renderMediaPreview = () => {

        /* ---------- LOCATION PREVIEW ---------- */
        if (messageType === "Location") {
            return (
                <div className="media-preview-item">
                    <img
                        src="https://upload.wikimedia.org/wikipedia/commons/8/88/Openstreetmap_logo.svg"
                        alt="Map preview"
                        style={{
                            width: "100%",
                            height: "200px",
                            borderRadius: "15px",
                            objectFit: "cover",
                            backgroundColor: "#e5ddd5"
                        }}
                    />

                    {address && (
                        <div className="message-bubble" style={{ marginTop: "8px" }}>
                            📍 {address}
                        </div>
                    )}
                </div>
            );
        }

        if (!media) return null;
        const mime = media.type;

        if (mime.startsWith("image")) {
            return (
                <div className="media-preview-item">
                    <span role="img" aria-label="image" style={{ fontSize: "24px", marginRight: "5px" }}>🖼️</span>
                    <img src={URL.createObjectURL(media)} alt="media" style={{ maxWidth: "100%", maxHeight: "200px", display: "block", marginTop: "5px" }} />
                </div>
            );
        } else if (mime.startsWith("video")) {
            return (
                <div className="media-preview-item">
                    <span role="img" aria-label="video" style={{ fontSize: "24px", marginRight: "5px" }}>🎬</span>
                    <video controls src={URL.createObjectURL(media)} style={{ maxWidth: "100%", maxHeight: "200px", display: "block", marginTop: "5px" }} />
                </div>
            );
        } else if (mime.startsWith("audio")) {
            return (
                <div className="media-preview-item">
                    <span role="img" aria-label="audio" style={{ fontSize: "24px", marginRight: "5px" }}>🎵</span>
                    <audio controls src={URL.createObjectURL(media)} style={{ display: "block", marginTop: "5px" }} />
                </div>
            );
        } else {
            return (
                <div className="media-preview-item">
                    <span role="img" aria-label="document" style={{ fontSize: "24px", marginRight: "5px" }}>📄</span>
                    <span>{media.name}</span>
                </div>
            );
        }
    };

    //Handle .txt or .csv file upload
    const handleFileUpload = (e) => {
        const uploadedFile = e.target.files[0];
        setFile(uploadedFile);
        setFileLineCount(0);

        if (!uploadedFile) return;

        const reader = new FileReader();

        reader.onload = (event) => {
            const text = event.target.result;

            const lines = text
                .split(/\r?\n/)
                .map((line) => line.trim())
                .filter((line) => line.length > 0);

            setFileLineCount(lines.length);
        };

        reader.readAsText(uploadedFile);
    };

    //Save 
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            // ---------- VALIDATIONS ----------
            if (mode === "number" && countNumbers === 0) {
                alert("Please enter at least one number");
                return;
            }

            if (mode === "file" && !file) {
                alert("Please upload a TXT or CSV file");
                return;
            }

            if (messageType !== "Text" && messageType !== "Location" && !media) {
                alert(`Please upload ${messageType}`);
                return;
            }

            if (messageType === "Location") {
                if (!latitude || !longitude) {
                    alert("Latitude and Longitude are required");
                    return;
                }
            }

            if (sendType === "schedule" && (!date || !time)) {
                alert("Please select date and time");
                return;
            }

            // ---------- FORM DATA ----------
            const formData = new FormData();

            // Numbers info
            formData.append("mode", mode);
            formData.append("phone", phone); // textarea numbers
            if (file) formData.append("numberFile", file);

            // Message info
            formData.append("messageType", messageType);
            formData.append("message", message);
            if (media) formData.append("media", media);

            if (messageType === "Location") {
                formData.append("latitude", latitude);
                formData.append("longitude", longitude);
                formData.append("address", address);
            }

            // Send options
            formData.append("sendType", sendType);
            if (sendType === "schedule") {
                formData.append("date", date);
                formData.append("time", time);
            }

            // Total numbers (optional but useful)
            formData.append(
                "totalNumbers",
                mode === "number" ? countNumbers : fileLineCount
            );

            // ---------- API CALL ----------
            const result = await apiPost("/msg/send-message", formData, true);

            // ---------- SUCCESS ----------
            alert(result.message || "Message submitted successfully!");
            console.log("API Response:", result);

            // After successful send, refresh balance and update navbar
            try {
                const balPayload = {
                    UserId: sessionStorage.getItem("username"),
                    WANO: sessionStorage.getItem("wano")
                };
                const balData = await apiPost("/customers/GetUserBalance", balPayload);
                if (balData && balData.balance !== undefined) {
                    // store as string
                    sessionStorage.setItem("balance", String(balData.balance));
                    // notify other components (Navbar) about update
                    try {
                        window.dispatchEvent(new CustomEvent("balanceUpdated", { detail: balData.balance }));
                    } catch (e) {
                        console.warn("Could not dispatch balanceUpdated event", e);
                    }
                }
            } catch (balErr) {
                console.error("Failed to refresh balance:", balErr);
            }

        } catch (error) {
            console.error("Send failed:", error);

            // ---------- SHOW ACTUAL ERROR ----------
            if (error.details?.message) {
                alert(error.details.message);
            } else if (error.message) {
                alert(error.message);
            } else {
                alert("Error while sending message");
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Navbar />

            <div className="page-container send-layout" style={{ display: "flex", gap: "5px", flexWrap: "wrap", marginTop: "0" }}>
                {/* PAGE HEADER BAR */}
                <div className="page-header-bar">
                    <h2>Send Message</h2>
                </div>

                {/* Left Column: Controls */}
                <div style={{ flex: 1, minWidth: "300px" }}>
                    {/* Numbers Card */}
                    <div className="card send-card">
                        <h3>Numbers</h3>
                        <div className="section-title">Select Mobile Number Input Method</div>
                        <div className="radio-group">
                            <label>
                                <input
                                    type="radio"
                                    value="number"
                                    checked={mode === "number"}
                                    onChange={() => setMode("number")}
                                />{" "}
                                Enter Number
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    value="file"
                                    checked={mode === "file"}
                                    onChange={() => setMode("file")}
                                />{" "}
                                Upload TXT/CSV File
                            </label>
                        </div>

                        {mode === "number" && (
                            <>
                                <textarea
                                    className="message-box"
                                    placeholder="Enter mobile numbers (comma OR newline separated)"
                                    value={phone}
                                    onChange={(e) => {
                                        const cleaned = e.target.value.replace(/[^\d+\n, ]+/g, "");
                                        setPhone(cleaned);
                                    }}
                                />
                                {/* <div style={{ fontSize: "13px", marginTop: "-10px", color: "#2e7d32" }}>
                                    Total Numbers: {countNumbers}
                                </div> */}
                            </>
                        )}

                        {mode === "file" && (
                            <div className="file-upload-section">
                                <label>Upload .txt or .csv containing numbers</label>
                                <input
                                    className="file-input"
                                    type="file"
                                    accept=".txt,.csv"
                                    //onChange={(e) => setFile(e.target.files[0])}
                                    onChange={handleFileUpload}
                                />
                            </div>
                        )}
                        {/* ✅ SHOW COUNT FOR BOTH MODES */}
                        <div style={{ fontSize: "13px", marginTop: "10px", color: "#2e7d32" }}>
                            Total Numbers: {mode === "number" ? countNumbers : fileLineCount}
                        </div>
                    </div>

                    {/* Message Card */}
                    <div className="card send-card">
                        <h3>Message</h3>
                        <div className="section-title">Select Message Type</div>
                        <div className="radio-group">
                            {["Text", "Image", "Video", "Audio", "Document", "Location"].map((type) => (
                                <label key={type}>
                                    <input
                                        type="radio"
                                        value={type}
                                        checked={messageType === type}
                                        onChange={() => {
                                            setMessageType(type);
                                            setMedia(null);
                                            setLatitude("");
                                            setLongitude("");
                                            setAddress("");
                                            if (fileInputRef.current) fileInputRef.current.value = null;
                                        }}
                                    />{" "}
                                    {type}
                                </label>
                            ))}
                        </div>

                        <div className="section-title">Enter WhatsApp Message</div>
                        <textarea
                            className="message-box"
                            placeholder="Type your message here..."
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                        />

                        {messageType !== "Text" && messageType !== "Location" && (
                            <>
                                <div className="section-title">Upload {messageType} (Optional)</div>
                                <input
                                    ref={fileInputRef}
                                    className="file-input"
                                    type="file"
                                    accept={getAcceptType()}
                                    onChange={(e) => setMedia(e.target.files[0])}
                                />
                            </>
                        )}

                        {messageType === "Location" && (
                            <>
                                <div className="section-title">Location Details</div>

                                {/* Latitude & Longitude in same row */}
                                <div className="flex-row">
                                    <input
                                        className="input-field"
                                        type="text"
                                        placeholder="Latitude"
                                        value={latitude}
                                        onChange={(e) => setLatitude(e.target.value)}
                                    />

                                    <input
                                        className="input-field"
                                        type="text"
                                        placeholder="Longitude"
                                        value={longitude}
                                        onChange={(e) => setLongitude(e.target.value)}
                                    />
                                </div>

                                {/* Address */}
                                <textarea
                                    className="message-box"
                                    placeholder="Address / Location Description"
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                />
                            </>
                        )}

                    </div>

                    {/* Actions Card */}
                    <div className="card send-card">
                        <h3>Actions</h3>
                        <div className="section-title">Send Options</div>
                        <div className="radio-group">
                            <label>
                                <input
                                    type="radio"
                                    value="instant"
                                    checked={sendType === "instant"}
                                    onChange={() => setSendType("instant")}
                                />{" "}
                                Send Instantly
                            </label>
                            {/* <label>
                                <input
                                    type="radio"
                                    value="schedule"
                                    checked={sendType === "schedule"}
                                    onChange={() => setSendType("schedule")}
                                />{" "}
                                Schedule
                            </label> */}
                        </div>

                        {sendType === "schedule" && (
                            <div className="flex-row" style={{ gap: "10px", marginTop: "10px" }}>
                                <input
                                    className="date-input"
                                    type="date"
                                    value={date}
                                    onChange={(e) => setDate(e.target.value)}
                                />
                                <input
                                    className="time-input"
                                    type="time"
                                    value={time}
                                    onChange={(e) => setTime(e.target.value)}
                                />
                            </div>
                        )}

                        <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
                            <button 
                                className="button" 
                                onClick={handleSubmit}
                                disabled={isLoading}
                                style={{ opacity: isLoading ? 0.6 : 1, cursor: isLoading ? "not-allowed" : "pointer" }}
                            >
                                {isLoading 
                                    ? "Sending..." 
                                    : (sendType === "instant" ? "Send Message" : "Schedule Message")
                                }
                            </button>
                            <button
                                className="button"
                                style={{ backgroundColor: "#f44336" }}
                                onClick={handleReset}
                                disabled={isLoading}
                            >
                                Reset
                            </button>
                        </div>
                    </div>
                </div>

                {/* Right Column: Preview */}
                <div className="message-preview-column">
                    <div className="card message-preview-card">
                        <h3>Preview</h3>
                        <div className="message-preview">
                            {renderMediaPreview()}
                            {message && <div className="message-bubble">{message}</div>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
